import {
  SETTING_ADD_REQUEST,
  SETTING_ADD_SUCCESS,
  SETTING_ADD_FAIL,
  SETTING_LIST_REQUEST,
  SETTING_LIST_SUCCESS,
  SETTING_LIST_FAIL,
  SETTING_LIST_RESET,
  SETTING_UPDATE_REQUEST,
  SETTING_UPDATE_SUCCESS,
  SETTING_UPDATE_FAIL
} from '../constants/settingConstants'

export const settingAddReducer = (state = {}, action) => {
  switch (action.type) {
    case SETTING_ADD_REQUEST:
      return { loading: true }
    case SETTING_ADD_SUCCESS:
      return { loading: false, successadd: true, settings: action.payload }
    case SETTING_ADD_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

export const settingListReducer = (state = { settings: {} }, action) => {
  switch (action.type) {
    case SETTING_LIST_REQUEST:
      return { loading: true, settings: {} }

    case SETTING_LIST_SUCCESS:
      return {
        loadinglist: false,
        settings: action.payload,
        success: true
      }

    case SETTING_UPDATE_SUCCESS:
      return {
        loadinglist: false,
        settings: action.payload,
        success: true
      }

    case SETTING_LIST_FAIL:
      return { loading: false, settings: {}, error: action.payload }

    case SETTING_LIST_RESET:
      return { settings: {} }
    default:
      return state
  }
}

export const settingListresetReducer = (state = { settings: {} }, action) => {
  switch (action.type) {
    case SETTING_LIST_RESET:
      return { settings: {} }
    default:
      return state
  }
}

export const settingUpdateReducer = (state = { settings: {} }, action) => {
  switch (action.type) {
    case SETTING_UPDATE_REQUEST:
      return { loading: true }
    case SETTING_UPDATE_SUCCESS:
      return { loading: false, success: true, settings: action.payload }
    case SETTING_UPDATE_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}
